const translations = {
	title: ['Contatta %%MINISITE_NAME%%', 'Contact %%MINISITE_NAME%%', 'Kontakt %%MINISITE_NAME%%'],
	found_on_asiagoit: [
		'Ricordati di dire che ci hai trovato su Asiago.it!',
		'Remember to say that you found us on Asiago.it!',
		'Denken Sie daran zu sagen, dass Sie uns auf Asiago gefunden haben.',
	],
	phone_description: [
		'Potresti avere accesso a sconti o promozioni riservate.',
		'You may have access to confidential discounts or promotions.',
		'Möglicherweise haben Sie Zugriff auf vertrauliche Rabatte oder Werbeaktionen.',
	],
	or: ['oppure', 'or', 'oder'],
	send_message: ['Invia messaggio', 'Send message', 'Nachricht senden'],
	message_form: [
		'Se preferisci, puoi anche inviarci un messaggio utilizzando il form di contatto email presente nella',
		'If you prefer, you can also send us a message using the email contact form in the',
		'Wenn Sie dies bevorzugen, können Sie uns auch eine Nachricht über das E-Mail-Kontaktformular in der E-Mail-Ansprechpartner senden',
	],
	contact_page: ['pagina contatti.', 'contact page.', 'kontaktseite.'],
	happy_to_help: [
		'Saremo felici di rispondere a qualsiasi domanda o richiesta che potresti avere!',
		'We will be happy to answer any question or request that you might have!',
		'Gerne beantworte wir jede Frage oder Anfrage, die Sie möglicherweise haben!',
	],
}

export function getTranslations(langId) {
	const data = {}

	for (const [key, value] of Object.entries(translations)) {
		data[key] = value[langId - 1]
	}

	return data
}
